import {AuthGuard} from '../../shared/guards/AuthGuard';
import {SinisterListPresentation} from './components';
import {Sidebar} from '../../shared/components';

export const SinisterListPage = (): JSX.Element => {
    return (
        <AuthGuard>
            <Sidebar>
                <SinisterListPresentation/>
            </Sidebar>
        </AuthGuard>
    )
};